import baseService from './baseService'

export const preLoginService = {
    getLogoData,
    init
}

function getLogoData() {
    return baseService.getRequest('/api/preLogin/logoData')
}

function init (client) {
    return baseService.postRequest('/api/preLogin/init', { url: client })
}
